import { styled } from 'styles';

export const StyledLoadingOverlay = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: ${({ theme }) => theme.spacing.relative.medium};
  opacity: 0.7;
  user-select: none;
`;

StyledLoadingOverlay.displayName = 'LoadingOverlay.Styled';
